import { toast } from "sonner";
import { Sentry } from "@/lib/sentry";
import { ApiError, getLocalUserFacingApiMessage, getUserFacingApiMessage } from "@/lib/api-client";

/**
 * Toast a tenant-safe script-review error. Client-side validation errors (plain
 * Error, not ApiError) keep their message; API/worker failures use generic copy.
 * Readiness 409 responses stay precise — the server message is intentional UX.
 */
export function toastScriptReviewError(error: unknown): void {
  Sentry.captureException(error);
  if (error instanceof ApiError && error.status === 409) {
    toast.error(error.message);
    return;
  }
  if (error instanceof ApiError) {
    const message = getLocalUserFacingApiMessage(error);
    if (message) toast.error(message);
    return;
  }
  if (error instanceof Error) {
    toast.error(error.message);
    return;
  }
  toast.error(getUserFacingApiMessage(error));
}
